import { createSvgIcon } from '@mui/material';

export const EditIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m12.8667 5.95004-2.8334-2.8.9334-.93333c.2555-.25556.5694-.38334.9416-.38334.3723 0 .6861.12778.9417.38334l.9333.93333c.2556.25556.3889.56389.4.925.0111.36111-.1111.66945-.3666.925l-.95.95Zm-.9667.98333L4.83333 14H2v-2.8333l7.06667-7.06666L11.9 6.93337Z"
    />
  </svg>,
  'EditIcon',
);
